import { VueReCaptcha } from 'vue-recaptcha-v3'
import { RecaptchaService } from '~/services/RecaptchaService'

export default defineNuxtPlugin(async (nuxtApp) => {
  const config = useRuntimeConfig()
  const fallbackSiteKey = config.public.recaptcha?.siteKey || ''
  
  // RecaptchaService instance
  const recaptchaService = RecaptchaService.getInstance()
  
  // Backend'den site key'i almaya çalış
  let siteKey: string | null = null
  try {
    siteKey = await recaptchaService.getSiteKey()
  } catch (error) {
    console.error('reCAPTCHA site key alınırken hata oluştu:', error)
  }
  
  // Backend'den alınamadıysa fallback kullan
  if (!siteKey) {
    console.warn('reCAPTCHA site key backend\'den alınamadı, fallback kullanılıyor:', fallbackSiteKey ? 'Anahtar var' : 'Anahtar yok')
    siteKey = fallbackSiteKey
  }
  
  // Site key yoksa plugin'i yükleme
  if (!siteKey) {
    console.warn('reCAPTCHA site key bulunamadı. reCAPTCHA devre dışı.')
    
    // Yine de recaptcha metodunu tanımla (dummy)
    nuxtApp.provide('recaptcha', {
      execute: async (action: string) => {
        console.warn('reCAPTCHA devre dışı, dummy token döndürülüyor')
        return 'dummy-token-recaptcha-disabled'
      }
    })
    
    return
  }
  
  // Vue reCAPTCHA'yı yükle
  nuxtApp.vueApp.use(VueReCaptcha, {
    siteKey: siteKey,
    loaderOptions: {
      autoHideBadge: config.public.recaptcha?.hideBadge || false,
      useRecaptchaNet: true,
    }
  })
  
  // Execute metodu için wrapper
  nuxtApp.provide('recaptcha', {
    execute: async (action: string) => {
      // @ts-ignore
      if (nuxtApp.vueApp.$recaptcha) {
        // @ts-ignore
        return await nuxtApp.vueApp.$recaptcha.execute(action)
      } else {
        console.warn('reCAPTCHA yüklenemedi, dummy token döndürülüyor')
        return 'dummy-token-recaptcha-not-loaded'
      }
    }
  })
}) 